<template>
  <v-app>
    <v-container fluid class="article-actions">
      <v-row>
        <v-col cols="2">
          <v-subheader>عنوان</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-text-field placeholder="عنوان" v-model="title"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>ترتیب نمایش</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-text-field
            placeholder="ترتیب نمایش"
            v-model="displayOrder"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row
        ><v-col md="2">
          <v-subheader>فعال</v-subheader>
        </v-col>
        <v-col md="8">
          <v-switch
            v-model="isDisable"
            color="indigo darken-3"
            hide-details
          ></v-switch>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="2">
          <v-subheader>تصویر</v-subheader>
        </v-col>
        <v-col md="8">
          <ImageUploader :imageUrl="image" @image-file="imageFile" />
        </v-col>
      </v-row>
      <v-row justify="center mb-2">
        <v-btn
          class="ml-4 white--text font-weight-bold indigo darken-4 white--text"
          @click="editHandler"
        >
          ثبت کردن
        </v-btn>
        <router-link to="/addendums">
          <v-btn class="white--text font-weight-bold indigo lighten-2">
            انصراف
          </v-btn>
        </router-link>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import baseURL from "@/axios";
import ImageUploader from "../addendums/components/ImageUploadAdd.vue";
export default {
  components:{ImageUploader},
  created() {
    ///Get All Brands
    axios
      .get(`${baseURL}ProviderAddendum/GetById?id=${this.$route.params.id}`)
      .then((res) => {
        this.title = res.data.data.title;
        this.image = res.data.data.image;
        this.displayOrder = res.data.data.displayOrder;
        this.isDisable = res.data.data.isDisable;
    });
  },

  data() {
    return {
      id: this.$route.params.id,
      title: "",
      image: "",
      list: [],
      items: [],
      displayOrder: 0,
      isDisable: true,
      listCategory: [],
      selectItem: null,
    };
  },
  computed: {
    ...mapGetters(["tokenValue", "articleInfoValue", "itemList"]),
  },
  methods: {
    imageFile(event) {
      this.image = event;
    },
    async editHandler() {
      const fd = new FormData();
      fd.append("image", this.image);
      ////////console.log(fd);
      this.listCategory.map((item) => {
        if (item.title == this.selectItem) {
          this.selectItem = item.id;
        }
      });
      await axios
        .put(
          `${baseURL}ProviderAddendum/Edit`,
          {
            id:this.id,
            title: this.title,
            displayOrder: this.displayOrder,
            isDisable : this.isDisable,
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        )
            .then((respon) => {
              const fdd = new FormData();

              fdd.append("image", this.image);
              axios
                .post(
                  `${baseURL}ProviderAddendum/UploadImage?id=${respon.data.data.id}`,
                  fdd,
                  {
                    headers: {
                      Authorization: `Bearer ${sessionStorage.getItem(
                        "token"
                      )}`,
                      "Content-Type": "multipart/form-data",
                    },
                  }
                )
                    .then(() => {
                          this.$router.push("/addendums");
                    });
            });
    },
  },
};
</script>

<style>
.article-actions {
  background: #ffffff;
  height: auto;
}
.v-input__control {
  direction: ltr;
}
.v-input__slot {
  flex-direction: row-reverse;
}
.v-application--wrap {
  min-height: auto !important;
}
.theme--light.v-input input {
  text-align: right;
}
</style>